import React from 'react';
import { usePermissions } from '../../hooks/usePermissions';

/**
 * Actions conditionnelles pour les tableaux basées sur les permissions
 */
const ConditionalActions = ({ 
  entity, 
  onEdit, 
  onDelete, 
  onView,
  editLabel = "Modifier",
  deleteLabel = "Supprimer",
  viewLabel = "Voir",
  editIcon: EditIcon,
  deleteIcon: DeleteIcon,
  viewIcon: ViewIcon,
  className = "flex space-x-2"
}) => {
  const { canUpdate, canDelete, canRead } = usePermissions();

  return (
    <div className={className}>
      {canRead(entity) && onView && (
        <button
          onClick={onView}
          className="text-blue-600 hover:text-blue-900 p-1"
          title={viewLabel}
        >
          {ViewIcon && <ViewIcon size={16} />}
        </button>
      )}
      
      {canUpdate(entity) && onEdit && (
        <button
          onClick={onEdit}
          className="text-yellow-600 hover:text-yellow-900 p-1"
          title={editLabel}
        >
          {EditIcon && <EditIcon size={16} />}
        </button>
      )}
      
      {canDelete(entity) && onDelete && (
        <button
          onClick={onDelete}
          className="text-red-600 hover:text-red-900 p-1"
          title={deleteLabel}
        >
          {DeleteIcon && <DeleteIcon size={16} />}
        </button>
      )}
    </div>
  );
};

export default ConditionalActions;
